// Ceilings mirror the server-side validation exactly, so the editor can never assemble a list
// the backend will reject.
export const MAX_EXPECTED_DELIVERABLES = 20;
export const MAX_EXPECTED_DELIVERABLE_LENGTH = 500;

// Expected deliverables are replaced atomically by the management update — there is no
// per-item endpoint — so the whole list is normalised in exactly one place: trimmed, blanks
// dropped, each entry capped and the list itself capped.
//
// Dropping blanks here is what lets the editor keep an empty row on screen for the next entry
// without ever sending it.
export const normalizeExpectedDeliverables = (values: string[]): string[] => {
    if (!Array.isArray(values)) {
        return [];
    }

    return values
        .map((value) => (typeof value === 'string' ? value.trim() : ''))
        .filter((value) => value.length > 0)
        .map((value) => value.slice(0, MAX_EXPECTED_DELIVERABLE_LENGTH))
        .slice(0, MAX_EXPECTED_DELIVERABLES);
};
